var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"xl","button-size":"sm","hide-footer":"","title":_vm.prefix + _vm.title},on:{"hidden":_vm.close,"close":_vm.close},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('LocalArmazenamentoList',{on:{"close":_vm.localSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }